import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper.min.mjs';
import Navigation from 'https://cdn.jsdelivr.net/npm/swiper@11/modules/navigation.min.mjs';
import Fade from 'https://cdn.jsdelivr.net/npm/swiper@11/modules/effect-fade.min.mjs';
import Pagination from 'https://cdn.jsdelivr.net/npm/swiper@11/modules/pagination.min.mjs';

const searchResultsSlider = () => {

    const searchSwiper = new Swiper('.m-search-results-slider__swiper', {
        modules: [Navigation, Fade, Pagination],
        loop: true,
        //effect: "fade", // undecided to use fade or not
        speed: 400,
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
      },
    });
}

export default searchResultsSlider;
